<template>
  <validation-observer
    ref="observer"
    tag="form">
    <validation-provider
      name="file-upload"
      :rules="fileUploadRules"
      slim>
      <template slot-scope="{ errors }">
        <div v-element-loader="{ endpoint: 'order-return/uploadFile' }" class="order-return-file-upload">
          <div v-for="(row, key) in uploadedFiles" :key="`uploaded-file-${key}`">
            <div class="order-return-uploaded-file">
              <div class="order-return-uploaded-file-icon">
                <img style="max-height: 96px;" :src="`/mvcapi/se/sv/order-return/attachment-thumbnail/${row.id}?orderNumber=${orderNumber}&token=${encodeURIComponent(token)}`">
                <div class="order-return-uploaded-file-remove" @click="removeFile(key)">
                  &#10006;
                </div>
              </div>
              <div class="order-return-uploaded-file-name">
                {{ row.name }}
              </div>
            </div>
          </div>

          <label for="upload-article-file" class="order-return-file-upload__label">
            <input
              id="upload-article-file"
              type="file"
              class="order-return-file-upload__input"
              accept=".png,.jpg,.jpeg,.webp,.mp4,.mpeg,.mpg,.tiff,.gif"
              @change="articleFileChange">
          </label>

          <div class="order-return-file-upload__content-container">
            <span class="issue-message-attachment-icon"></span>
            <label for="upload-article-file" class="order-return-file-upload__text">
              <span class="order-return-file-upload__main-text">{{ t('orderReturnUploadText') }}</span>
              <span class="order-return-file-upload__sub-text">{{ t('orderReturnUploadSubText') }}</span>
            </label>
          </div>
        </div>
        <div v-if="errors.length > 0" class="input__message">
          <template v-for="error in errors">
            <div :key="`input-error-${error}`" class="input__message--error">
              {{ error }}
            </div>
          </template>
        </div>
      </template>
    </validation-provider>
  </validation-observer>
</template>

<script>
import httpService from '@/core/http-service'
import _ from 'lodash'

export default {
  props: {
    orderNumber: {
      type: String,
      default: ''
    },
    token: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    uploadedFiles: []
  }),
  computed: {
    fileUploadRules() {
      return this.required && this.uploadedFiles.length === 0 ? 'required' : ''
    }
  },
  watch: {
    uploadedFiles: {
      handler: function (newUploadedFiles, oldUploadedFiles) {
        this.publish('order-return-file-upload-updated', newUploadedFiles)
      },
      deep: true
    }
  },
  methods: {
    articleFileChange(e) {
      this.publish('clean-file-upload-message')

      const file = _.get(e, 'target.files[0]')

      if (file) {
        httpService.uploadFile(`order-return/attachment?orderNumber=${this.orderNumber}&token=${encodeURIComponent(this.token)}`, file).then((response) => {
          this.publish('order-return-file-uploaded', response.data)

          this.uploadedFiles.push({
            id: response.data.id,
            name: response.data.name
          })

          document.getElementById('upload-article-file').value = null
        })
      }
    },
    removeFile(rowID) {
      this.uploadedFiles.splice(rowID, 1)
    }
  }
}
</script>

<style lang="scss">
  .order-return-file-upload {
    display: inline-flex;
    align-items: flex-start;
  }

  .order-return-file-upload__label {
    display: inline-block;
    width: 2.5rem;
    height: 2.5rem;
    margin-right: .8rem;
    background-image: url("data:image/svg+xml,%3C%3Fxml%20version%3D%221.0%22%20encoding%3D%22UTF-8%22%20standalone%3D%22no%22%3F%3E%0D%0A%3Csvg%0D%0A%20%20%20width%3D%2240%22%0D%0A%20%20%20height%3D%2240%22%0D%0A%20%20%20viewBox%3D%220%200%2040%2040%22%0D%0A%20%20%20version%3D%221.1%22%0D%0A%20%20%20id%3D%22svg14%22%0D%0A%20%20%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%0D%0A%20%20%20xmlns%3Asvg%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0D%0A%20%20%3Cdefs%0D%0A%20%20%20%20%20id%3D%22defs18%22%20%2F%3E%0D%0A%20%20%3Cg%0D%0A%20%20%20%20%20fill%3D%22%23757272%22%0D%0A%20%20%20%20%20fill-rule%3D%22nonzero%22%0D%0A%20%20%20%20%20id%3D%22g12%22%3E%0D%0A%20%20%20%20%3Cpath%0D%0A%20%20%20%20%20%20%20d%3D%22M%202.8%2C37.2%20V%202.8%20h%2016.629%20l%207.638%2C7.808%20v%205.124%20h%202.4%20V%209.629%20L%2020.438%2C0.4%20H%200.4%20v%2039.2%20h%2017.2%20v%20-2.4%20z%22%0D%0A%20%20%20%20%20%20%20id%3D%22path4%22%20%2F%3E%0D%0A%20%20%20%20%3Cpath%0D%0A%20%20%20%20%20%20%20d%3D%22m%2029.2%2C39.6%20c%205.744%2C0%2010.4%2C-4.656%2010.4%2C-10.4%200%2C-5.744%20-4.656%2C-10.4%20-10.4%2C-10.4%20-5.744%2C0%20-10.4%2C4.656%20-10.4%2C10.4%200%2C5.744%204.656%2C10.4%2010.4%2C10.4%20z%20m%200%2C-2.4%20a%208%2C8%200%201%201%200%2C-16%208%2C8%200%200%201%200%2C16%20z%22%0D%0A%20%20%20%20%20%20%20id%3D%22path6%22%20%2F%3E%0D%0A%20%20%20%20%3Cpath%0D%0A%20%20%20%20%20%20%20d%3D%22m%2031.951%2C30.049%201.698%2C-1.698%20-4.449%2C-4.448%20-4.449%2C4.448%201.698%2C1.698%202.751%2C-2.752%20z%22%0D%0A%20%20%20%20%20%20%20id%3D%22path8%22%20%2F%3E%0D%0A%20%20%20%20%3Cpath%0D%0A%20%20%20%20%20%20%20d%3D%22M%2030.4%2C33.615%20V%2025.6%20H%2028%20v%208.015%20z%22%0D%0A%20%20%20%20%20%20%20id%3D%22path10%22%20%2F%3E%0D%0A%20%20%3C%2Fg%3E%0D%0A%20%20%3Cellipse%0D%0A%20%20%20%20%20style%3D%22fill%3A%23ffffff%3Bstroke-width%3A0.377953%3Bstroke-dasharray%3A0.377953%2C%209.07087%22%0D%0A%20%20%20%20%20id%3D%22path2146%22%0D%0A%20%20%20%20%20cx%3D%2210.192307%22%0D%0A%20%20%20%20%20cy%3D%2213.990385%22%0D%0A%20%20%20%20%20rx%3D%221.7307693%22%0D%0A%20%20%20%20%20ry%3D%221.5865384%22%20%2F%3E%0D%0A%20%20%3Cellipse%0D%0A%20%20%20%20%20style%3D%22fill%3A%23757272%3Bfill-opacity%3A1%3Bstroke%3Anone%3Bstroke-width%3A0.175935%3Bstroke-dasharray%3A0.175935%2C%204.22244%22%0D%0A%20%20%20%20%20id%3D%22path2250%22%0D%0A%20%20%20%20%20cx%3D%229.98592%22%0D%0A%20%20%20%20%20cy%3D%2216.404041%22%0D%0A%20%20%20%20%20rx%3D%221.8575017%22%0D%0A%20%20%20%20%20ry%3D%221.7903631%22%20%2F%3E%0D%0A%20%20%3Cpath%0D%0A%20%20%20%20%20id%3D%22path3359%22%0D%0A%20%20%20%20%20d%3D%22M%2021.722656%2C13.243437%2013.856942%2C23.180202%2011.536887%2C19.991117%205.3805251%2C26.53125%20H%2017.792969%20c%200.747516%2C-3.138978%202.76651%2C-5.781676%205.484375%2C-7.357422%20z%22%0D%0A%20%20%20%20%20style%3D%22fill%3A%23757272%3Bfill-opacity%3A1%3Bstroke%3Anone%22%20%2F%3E%0D%0A%3C%2Fsvg%3E");
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    &:hover {
      cursor: pointer;
    }
  }

  .order-return-file-upload__content-container {
    display: flex;
    flex-direction: column;
  }

  .order-return-file-upload__text {
    display: flex;
    flex-direction: column;
    margin-top: -.4rem;
  }

  .order-return-file-upload__label:hover + .order-return-file-upload__content-container .order-return-file-upload__text > *,
  .order-return-file-upload__text:hover > * {
    cursor: pointer;
    text-decoration: underline;
  }

  .order-return-file-upload__main-text {
    @include h3-semi-bold;
    color: color(text-blue);
  }

  .order-return-file-upload__sub-text {
    @include body-smaller;
    color: color(text);
  }

  .order-return-file-instructions__text--link {
    @include reset-link;
  }

  .order-return-file-upload__label:hover .order-return-file-upload__text {
    text-decoration: underline;
  }

  .order-return-file-upload__input {
    visibility: hidden;
    display: none;
  }

  .order-return-file-instructions {
    @include body-smaller;
  }

  .order-return-file-instructions__text {
    @include body-smaller-semi-bold;
    margin-top: 0;
    margin-bottom: measure(half);
  }

  .order-return-uploaded-file {
    display: flex;
    margin-right: .8rem;
    flex-direction: column;
    align-items: center;

    &:hover {
      cursor: pointer;
    }
  }

  .order-return-uploaded-file-icon {
    display: inline-block;
    position: relative;
  }

  .order-return-uploaded-file-icon > img {
    border: solid 1px #757272;
    min-width: 4rem;
    min-height: 4rem;
  }

  .order-return-uploaded-file-name {
  }

  .order-return-uploaded-file-remove {
    position: absolute;
    width: 1.4rem;
    height: 1.4rem;
    border-radius: .7rem;
    background-color: red;
    color: white;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    font-size: 1rem;
    top: -.5rem;
    right: -.5rem;
  }

</style>
